import { useState } from "react";

export default function QuoteFormSection() {
  const [formStatus, setFormStatus] = useState<"idle" | "submitting" | "success">("idle");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus("submitting");
    const form = e.currentTarget;
    const data = new FormData(form);
    try {
      const response = await fetch("https://formspree.io/f/xojzbvwg", {
        method: "POST",
        body: (() => { const p = new URLSearchParams(data as unknown as Record<string, string>); p.append("formulario","Presupuesto"); p.append("_subject","Nuevo presupuesto — Persianas Málaga"); return p; })(),
        headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
      });
      if (response.ok) {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("idle");
      }
    } catch {
      setFormStatus("idle");
    }
  };

  return (
    <section id="presupuesto" className="py-10 md:py-20 bg-gradient-to-br from-background-50 via-primary-50/30 to-accent-50/30">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-5 md:mb-6">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-2 md:mb-3 font-heading">
            Presupuesto en 30 segundos
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-2">
            Llámanos o escríbenos por WhatsApp. Respuesta en minutos en cualquier barrio de Málaga.
          </p>
          <p className="text-sm font-semibold text-primary-600">
            Respondemos en menos de 15 minutos
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="w-full bg-background-50 rounded-2xl p-6 md:p-8">
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Form */}
              <div className="flex-1">
                {formStatus === "success" ? (
                  <div className="text-center py-8">
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                      <span className="w-6 h-6 flex items-center justify-center"><i className="ri-check-line text-primary-600 text-xl"></i></span>
                    </div>
                    <p className="text-sm font-semibold text-foreground-900 mb-1">¡Presupuesto enviado!</p>
                    <p className="text-xs text-foreground-600">Te contactaremos en menos de 15 minutos.</p>
                    <button
                      onClick={() => setFormStatus("idle")}
                      className="mt-4 text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer"
                    >
                      Enviar otra solicitud
                    </button>
                  </div>
                ) : (
                  <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                      <label htmlFor="quote-name" className="block text-sm font-medium text-foreground-800 mb-1.5">Nombre</label>
                      <input id="quote-name" name="name" required className="w-full px-4 py-3.5 md:py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 text-foreground-900 placeholder:text-foreground-400" placeholder="Tu nombre" />
                    </div>
                    <div>
                      <label htmlFor="quote-phone" className="block text-sm font-medium text-foreground-800 mb-1.5">Teléfono</label>
                      <input id="quote-phone" name="phone" type="tel" required className="w-full px-4 py-3.5 md:py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 text-foreground-900 placeholder:text-foreground-400" placeholder="Tu teléfono" />
                    </div>
                    <div>
                      <label htmlFor="quote-email" className="block text-sm font-medium text-foreground-800 mb-1.5">Email (opcional)</label>
                      <input id="quote-email" name="email" type="email" className="w-full px-4 py-3.5 md:py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 text-foreground-900 placeholder:text-foreground-400" placeholder="tu@email.com" />
                    </div>
                    <div>
                      <label htmlFor="quote-service" className="block text-sm font-medium text-foreground-800 mb-1.5">¿Qué necesitas?</label>
                      <select id="quote-service" name="service" required className="w-full px-4 py-3.5 md:py-3 text-sm bg-background-100 border border-background-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-400/60 focus:border-primary-400 text-foreground-900 appearance-none cursor-pointer">
                        <option value="">Selecciona un servicio</option>
                        <option value="Persiana">Persiana</option>
                        <option value="Mosquiteras">Mosquiteras</option>
                        <option value="Motorización">Motorización</option>
                        <option value="Otro">Otro</option>
                      </select>
                    </div>
                    <button type="submit" disabled={formStatus === "submitting"} className="w-full min-h-[48px] py-3.5 px-6 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 disabled:from-primary-300 disabled:to-primary-300 text-background-50 font-semibold text-sm md:text-base rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20">
                      {formStatus === "submitting" ? "Enviando..." : "Solicitar presupuesto gratis"}
                    </button>
                  </form>
                )}
              </div>

              {/* Sidebar contact */}
              <div className="lg:w-64 flex flex-col justify-center gap-4 p-6 bg-background-100 rounded-xl">
                <p className="text-sm font-semibold text-foreground-800 font-heading">¿Prefieres llamar?</p>
                <a href="tel:+34951120770" className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-lg"></i></span>
                  951 12 07 70
                </a>
                <p className="text-xs text-foreground-500">Respuesta inmediata</p>
                <div className="border-t border-background-200 my-1" />
                <a href="https://wa.me/34627213347" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#25D366] hover:text-[#1faa52] font-medium text-sm transition-colors whitespace-nowrap cursor-pointer">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-fill text-lg"></i></span>
                  WhatsApp
                </a>
                <p className="text-xs text-foreground-500">Te respondemos al instante</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}